import { Helmet } from 'react-helmet-async';
import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import ProductDetails from '../components/product/productDetails/ProductDetails';
import { products } from '@/core/global-data/products.data';
import { useParams } from 'react-router-dom';
import MainSection from '@/components/MainSection';

export default function ProductPage() {
    const { t } = useTranslation();
    const { id } = useParams();
    const product = Number(id) ? products[Number(id) - 1] : products[0];
    const HeroIcon = (product.svg || product.background) as ComponentType<{ className?: string }> | undefined;
    const title = t(`products.${product.id}.title`);
    const mainDescription = t(`products.${product.id}.mainDescription`);
    const subtitle = product.hasSubtitle ? t(`products.${product.id}.subtitle`) : '';

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={mainDescription} />
                <link rel="canonical" href={`/${product.id}`} />
            </Helmet>
            <MainSection
                title={title}
                description={subtitle || mainDescription}
                icon={
                    HeroIcon ? (
                        <HeroIcon className="h-[180px] w-[180px] object-contain sm:h-[200px] sm:w-[210px]" />
                    ) : undefined
                }
            />
           
            <div className="w-full mb-12 lg:mb-[100px] relative overflow-hidden mainContainer">
                <ProductDetails product={product} />
            </div>
        </>
    );
}
